import { Accordion, Divider } from '@mui/material';
import AccordionSummaryComponent from './accordion-summary-component';
import AccordionDetailsComponent from './accordion-details-component';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const AccordionComponent: React.FC<any> = ({ client, updateClient }: any) => {
    const { t } = useTranslation();

    const [expanded, setExpanded] = useState<string | false>('panel1');

    const handlePanelChange: any = (panel: string) => (isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const removeHost = (host: string) => {
        const newClientData = {
            ...client!,
            hosts: client!.hosts.filter((h: string) => h !== host),
        };

        updateClient(newClientData, t('hostRemoved'));
    };
    return (
        <Accordion
            sx={{ width: '100%' }}
            expanded={expanded === 'panel1'}
            onChange={handlePanelChange('panel1')}
        >
            <AccordionSummaryComponent />
            <Divider />
            <AccordionDetailsComponent hosts={client.hosts} removeHost={removeHost} />
        </Accordion>
    );
};

export default AccordionComponent;
